<template>
  <q-card class="auth-card">
    <div class="auth-title">
      Вход в личный кабинет
    </div>
    <form class="auth-form" @submit.prevent="auth">
      <q-input
        v-model="login"
        outlined
        type="text"
        label="Логин"
        class="auth-input"
        :error="errorLogin"
        @focus="onFocus"
      />
      <q-input
        v-model="password"
        outlined
        :type="isPwd ? 'password' : 'text'"
        label="Пароль"
        class="auth-input"
        autocomplete="on"
        :error="errorPass"
        @focus="onFocus"
      >
        <template v-slot:append>
          <q-icon
            :name="isPwd ? 'visibility_off' : 'visibility'"
            class="cursor-pointer"
            autocomplete="on"
            @click="isPwd = !isPwd"
          />
        </template>
      </q-input>

      <q-btn
        unelevated
        color="primary"
        label="Войти"
        class="auth-btn"
        type="submit"
      />
    </form>
  </q-card>
</template>

<script>
/**
 * Авторизация
 * @module PageAuth/Component/CardAuth
 * */

import { ERR_PASS } from 'PageAuth/const'
import { notifyError } from 'Utils/notify'
import { LocalStorage } from 'quasar'
import {
  ROLE_ADMIN
} from 'Constants/roles'
import * as authService from 'API/auth'
import { AuthenticationService } from 'API/auth'
import { AuthResult } from 'API/Models/authResult'

export default {
  name: 'VueCardAuth',
  data: () => ({
    login: null,
    password: null,
    isPwd: true,
    errorPass: false,
    errorLogin: false,
    authService: new AuthenticationService()
  }),
  methods: {
    /**
    * Метод аторизации
    */
    async auth() {
      if (this.login === 'login' && this.password === 'password') {
        try {
          const authData =  await this.authService.login()
          LocalStorage.set('userRole', ROLE_ADMIN)
          LocalStorage.set('authentication_token', authData.token)
          this.authService.isAuthenticated()
          await this.$router.push({path:'/'})
        } catch (e) {
          console.error(e)
          notifyError(e.response?.data?.message)
        }
      } else {
        this.errorHandler()
      }
    },

    /**
    * Обработка ошибки аторизации
    * @param {String} err - текст с ошибкой (полчаем из бэка)
    */
    errorHandler(err) {
      let errText

      switch (err) {
        case ERR_PASS: {
          this.errorPass = true
          errText = 'Неправильно введен пароль'
          break
        }
        default: {
          this.errorPass = true
          this.errorLogin = true
          errText = 'Неправильно введен пароль или логин'
        }
      }

      notifyError(errText)
    },

    /**
    * Фокус на инпут, при фокусе сбрасываем влидацию
    */
    onFocus() {
      this.errorPass = false
      this.errorLogin = false
    }
  }
}
</script>

<style lang="scss" scoped>
.auth {
    &-card {
      width: 480px;
      height: 436px;
      border-radius: 10px;
      background-color: $color-white;
      margin: 0 auto;
      position: relative;
      top: 25%;
    }

    &-title {
        font-family: Roboto, sans-serif;
        font-weight: 900;
        font-size: 30px;
        font-stretch: normal;
        font-style: normal;
        letter-spacing: normal;
        color: $color-blue-3;
        margin-left: 36px;
        padding-top: 30px;
    }

    &-input {
      margin-top: 20px;
      margin-left: 30px;
      width: 420px;
    }

    &-input:first-child {
      margin-top: 0px;
    }

    &-btn {
      margin-top: 40px;
      margin-left: 30px;
      width: 420px;
      height: 56px;
      font-family: Roboto, sans-serif;
      font-weight: 900;
      font-size: 16px;
      border-radius: 6px;
    }

    &-forgot {
      font-family: Roboto, sans-serif;
      font-weight: 900;
      font-size: 14px;
      text-align: center;
      color: $color-blue-2;
      margin-top: 20px;
      margin-left: 185px;
      width: 110px;
      cursor: pointer;
    }

    &-forgot:hover {
      opacity: 0.7;
    }

    &-form {
      margin-top: 40px;
    }
}
</style>
